import { AuthStore } from "@/stores/authentication"
import { CustomerStore } from "@/stores/customer"
import { IStringIndexedArrayOfString } from "@/interface"

export const goToEnergy = (authStore: AuthStore|null, customerStore: CustomerStore|null, locale: string, forceMyMega = false): void => {
  const myMegaDefaultUrl = getDefaultUrlMyMega(locale)
  const redirect = (url: string) => {
    const a = document.createElement('a');
    a.href=url;
    a.target="_blank";
    a.click();
  }

  if (authStore && authStore.hasEnergy && customerStore) {
    customerStore.getUrlMyMega(locale)
      .then((url) => {
        redirect(url !== '' ? url : myMegaDefaultUrl);
      })
  } else if (forceMyMega) {
    redirect(myMegaDefaultUrl);
  } else {
    redirect(getDefaultUrlMegaWebsite(locale));
  }
}

export const getDefaultUrlMyMega = (locale: string, params?: IStringIndexedArrayOfString) => {
  const objParams = Object.assign({}, params ?? {} as IStringIndexedArrayOfString, { lang: locale })
  const newUrl = process.env.VUE_APP_URL_MYMEGA ?? ''
  const newParams = Object.entries(objParams).map(([key, value]) => {
    return value !== '' ? `${key}=${value}` : key
  }).join('&');

  return `${newUrl}?${newParams}`
}

export const getDefaultUrlMegaWebsite = (locale: string, path?: string) => {
  let newPath = path ?? ''
  let newUrl = process.env.VUE_APP_URL_MEGA ?? ''
  if (!newUrl?.endsWith('/')) {
    newUrl += '/'
  }
  if (newPath !== '' && !newPath.startsWith('/')) {
    newPath = "/" + newPath
  }

  return `${newUrl}${locale}${newPath}`
}